import React, { useState } from 'react';
import { HiOutlineUser, HiOutlineEnvelope, HiOutlinePhone } from 'react-icons/hi2';
import './Contact.css';

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', version: '', source: '', demo: '' });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');

    const emailBody = `
New PreciseCA Inquiry:

Name: ${form.name}
Email: ${form.email}
Phone: ${form.phone}
Interested Version: ${form.version}
Source of Reference: ${form.source}
Free Demo Requested: ${form.demo}
    `.trim();

    try {
      const response = await fetch('/send-email.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          phone: form.phone,
          version: form.version,
          source: form.source,
          demo: form.demo,
        }),
      });

      const result = await response.json();
      if (result.success) {
        setStatus('success');
        setForm({ name: '', email: '', phone: '', version: '', source: '', demo: '' });
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }

    setTimeout(() => setStatus(''), 5000);
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="contact-wrapper">
          {/* Left Side */}
          <div className="contact-info">
            <h2>Get Started with PreciseCA</h2>
            <p>Fill in your details and our team will reach out to help you choose the right plan for your business.</p>
            <div className="contact-features">
              <div className="contact-feature">
                <span className="cf-icon">&#10003;</span>
                <span>Free online demo available</span>
              </div>
              <div className="contact-feature">
                <span className="cf-icon">&#10003;</span>
                <span>No credit card required</span>
              </div>
              <div className="contact-feature">
                <span className="cf-icon">&#10003;</span>
                <span>Setup in under 30 minutes</span>
              </div>
              <div className="contact-feature">
                <span className="cf-icon">&#10003;</span>
                <span>Dedicated onboarding support</span>
              </div>
            </div>
          </div>

          {/* Right Side - Form */}
          <form className="contact-form" onSubmit={handleSubmit}>
            <h3>Request a Callback</h3>

            <div className="form-group">
              <label>Full Name</label>
              <div className="input-wrap">
                <HiOutlineUser className="input-icon" />
                <input type="text" name="name" placeholder="Enter your name" value={form.name} onChange={handleChange} required />
              </div>
            </div>

            <div className="form-group">
              <label>Email Address</label>
              <div className="input-wrap">
                <HiOutlineEnvelope className="input-icon" />
                <input type="email" name="email" placeholder="Enter your email" value={form.email} onChange={handleChange} required />
              </div>
            </div>

            <div className="form-group">
              <label>Contact Number</label>
              <div className="input-wrap">
                <HiOutlinePhone className="input-icon" />
                <input type="tel" name="phone" placeholder="Enter your phone number" value={form.phone} onChange={handleChange} required />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Interested Version</label>
                <select name="version" value={form.version} onChange={handleChange} required>
                  <option value="">Select Version</option>
                  <option value="Light Version">Light Version</option>
                  <option value="Ultimate Version">Ultimate Version</option>
                </select>
              </div>

              <div className="form-group">
                <label>Source of Reference</label>
                <select name="source" value={form.source} onChange={handleChange} required>
                  <option value="">Select Source</option>
                  <option value="Partner">Partner</option>
                  <option value="Google">Google</option>
                  <option value="Social Media">Social Media</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            </div>

            <div className="form-group">
              <label>Want a Free Online Demo?</label>
              <div className="demo-toggle">
                <button type="button" className={`toggle-btn ${form.demo === 'Yes' ? 'active' : ''}`} onClick={() => setForm({...form, demo: 'Yes'})}>
                  Yes
                </button>
                <button type="button" className={`toggle-btn ${form.demo === 'No' ? 'active' : ''}`} onClick={() => setForm({...form, demo: 'No'})}>
                  No
                </button>
              </div>
            </div>

            <button type="submit" className="btn-primary submit-btn" disabled={status === 'sending'}>
              {status === 'sending' ? 'Sending...' : 'Submit Request'}
            </button>

            {status === 'success' && (
              <div className="form-status success">Thank you! Our team will contact you shortly.</div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
